import service from "./service";
export const contact = (data) => {
    return service({
        url: `/contact`,
        method: 'POST',
        data: JSON.stringify(data),
    });
};
